
class ContentSearch {
    constructor(domNode){
        this.domNode = domNode;
        this.searchInput = this.domNode.querySelector('.search__input');
        this.searchSubmit = this.domNode.querySelector('.search__submit');
        this.searchClear = this.domNode.querySelector('.search__clear');
        this.resultsContainer = this.domNode.querySelector('.results-container');
        this.fetchUrl = this.domNode.getAttribute('data-fetch-url');
        this.items = [];

        this.loadedEvent = new Event('loaded');

        this.fetchItems(this.fetchUrl);

        this.searchInput.addEventListener(
            'keyup',
            this.handleSearchInputKeyup.bind(this)
        );

        this.searchSubmit.addEventListener(
            'click',
            this.handleSearchSubmitClick.bind(this)
        );

        this.searchClear.addEventListener(
            'click',
            this.handleSearchClearClick.bind(this)
        );
    }

    async fetchItems(url){
        try {
            const res = await fetch(url);
            this.items = await res.json();
            this.renderItems(this.items);
        } catch (err) {
            console.error(err);
        }
    }

    handleSearchSubmitClick(e){

    }

    handleSearchInputKeyup(e){
        const searchString = e.target.value.toLowerCase();
        let contentType;

        if (e.key === 'Enter') {
            this.resultsContainer.scrollIntoView({
                behavior: "auto"
            });
            return;
        }

        if (e.target.value) {
            this.searchClear.classList.remove('is-hidden');
        } else {
            this.searchClear.classList.add('is-hidden');
        }

        const filteredList = this.items.filter((item) => {
            let searchableContent = '';
            contentType = item.content_type;
            searchableContent += item.title.toLowerCase();
            searchableContent += ' ';

            if(item.children){
                for (var i = 0, l = item.children.length; i < l; i++) {
                    searchableContent += item.children[i].title.toLowerCase();
                    searchableContent += ' ';
                }
            }

            return (
                searchableContent.includes(searchString)
            );
        });

        setTimeout(() => {
            if (!this.resultsContainer.hasChildNodes()) {
                const noResults = document.createElement("div");
                const noResultText = document.createElement("h4");

                noResults.classList.add('no-results');
                
                if(contentType === "depot"){
                    noResults.classList.add('embla__slide');
                    noResultText.classList.add("sa-200", "x-large-body");
                }

                noResultText.textContent = 'Sorry, no results match your search...';
                
                noResults.appendChild(noResultText);
                this.resultsContainer.appendChild(noResults);
            }
        }, 100);

        this.renderItems(filteredList);
    }

    handleSearchClearClick(e){
        this.searchInput.value = '';
        this.renderItems(this.items);
        this.searchClear.classList.add('is-hidden');
    }

    renderItems(json){
        const htmlString = json.map(
            (item) => {
                let html = ``;
                if(item.content_type == 'depot'){
                    html = `
                    <div class="embla__slide">
                        <div class="depot-result">
                            <div tabindex="0" class="depot-location">
                                ${item.title}
                            </div>
                            <div class="depot-action">
                                <button class="depot-action--js" data-slug="${item.slug}">View</button>
                            </div>
                        </div>
                    </div>
                    `;
                }
                if(item.content_type == 'contact'){
                    html = `
                    <div class="card card--depot">
                        <div class="card__content">
                            <h3 class="depot-title">${item.title}</h3>
                            <div class="card__details card--depot__details">
                                <div class="card__detail card--depot__detail">
                                    <i class="sa-icon--phone"></i>
                                    <span class="depot-tel-value"><a href="tel:${item.tel}">${item.tel}</a></span>
                                </div>
                                
                                <div class="card__detail card--depot__detail">
                                    <i class="sa-icon--email"></i>
                                    <span class="depot-email-value"><a href="mailto:${item.email}">${item.email}</a></span>
                                </div>
                                
                                <div class="card__detail card--depot__detail">
                                    <i class="sa-icon--home"></i>
                                    <span class="depot-address-value">${item.address}</span>
                                </div>
        
                                <div class="card__detail card--depot__detail">
                                    <i class="sa-icon--calendar"></i>
                                    <div class="inner-items">
                                        <div class="depot-monfri depot-info-item ${item.opening_hours.monfri}">
                                            <span>Mon - Fri:</span> <span>:</span> <span>${item.opening_hours.monfri}</span>
                                        </div>
                                        <div class="depot-sat depot-info-item ${item.opening_hours.sat}">
                                            <span>Sat:</span> <span>:</span> <span>${item.opening_hours.sat}</span>
                                        </div>
                                        <div class="depot-sun depot-info-item ${item.opening_hours.sun}">
                                            <span>Sun:</span> <span>:</span> <span>${item.opening_hours.sun}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    `;
                }
                return html;
            }
        ).join('');

        this.resultsContainer.innerHTML = htmlString;

        this.resultsContainer.dispatchEvent(this.loadedEvent);
    }

}

exports.ContentSearch = ContentSearch;